module.exports = __webpack_public_path__ + "img/bankid.7afbfe14.svg";